import { render, staticRenderFns } from "./DDErrorPage.vue?vue&type=template&id=174337d0&scoped=true"
import script from "./DDErrorPage.vue?vue&type=script&lang=js"
export * from "./DDErrorPage.vue?vue&type=script&lang=js"
import style0 from "./DDErrorPage.vue?vue&type=style&index=0&id=174337d0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "174337d0",
  null
  
)

export default component.exports